import { useState } from 'react'
import { useAtom } from 'jotai'
import Button from '@mui/material/Button'
import SendRoundedIcon from '@mui/icons-material/SendRounded'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'

import type { SendYearlyFeePaymentEmailsResponse } from '@/types'
import { sendYearlyFeePaymentEmailsIdAtom } from '@/state'
import { useGenerateFeePayers } from '@/hooks/api/use-yearly-fee-collection'

export default function SendYearlyFeePaymentEmails({
    yearlyFeeCollectionId,
}: {
    yearlyFeeCollectionId: number,
}) {

    const [sendYearlyFeePaymentEmailsId, setSendYearlyFeePaymentEmailsId] = useAtom(sendYearlyFeePaymentEmailsIdAtom)
    const [requestInProgress, setRequestInProgress] = useState<boolean>(false)

    // Action dialogs
    const [confirm, setConfirm] = useState<boolean>(false)

    const successCallback = (data: SendYearlyFeePaymentEmailsResponse) => {
        if (data.id) {
            setSendYearlyFeePaymentEmailsId(data.id)
        }
    }

    const mutation = useGenerateFeePayers(
        yearlyFeeCollectionId,
        {
            onSuccessCallback: successCallback,
            setRequestInProgress,
        },
    )

    const handleClickGenerate = () => {
        setRequestInProgress(true)
        mutation.mutate()
        setConfirm(false)
    }

    return (
        <>
            <Button
                color="terciary"
                variant="outlined"
                startIcon={<SendRoundedIcon />}
                onClick={() => setConfirm(true)}
                // disabled={requestInProgress || !!sendYearlyFeePaymentEmailsId}
                // Temporarily disabled
                disabled
                sx={{
                    backgroundColor: 'errorRedLight.light',
                    borderColor: 'errorRedLight.dark',
                }}
            >
                3. Odeslat pokyny k platbě
            </Button>
            <Dialog
                open={confirm}
                onClose={() => setConfirm(false)}
            >
                <DialogContent>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                        <Typography variant="h5" component="div" mb={2}>
                            Potvrďte prosím odeslání emailů ke všem neuhrazeným platbám
                        </Typography>
                        <Typography variant="body2" component="div" mb={2}>
                            Tato akce projde všechna svozová místa a poplatníky v obci a všem poplatníkům a správcům svozových míst, u kterých evidujeme neuhrazenou platbu, odešle email s pokyny k platbě.
                        </Typography>
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexGrow: 1,
                        }}>
                            <Button
                                variant="text"
                                color="terciary"
                                onClick={() => setConfirm(false)}
                            >
                                Zrušit
                            </Button>
                            <Button
                                variant="contained"
                                color="error"
                                startIcon={requestInProgress ? <CircularProgress color="inherit" size={20} /> : <SendRoundedIcon />}
                                onClick={() => handleClickGenerate()}
                                disabled={requestInProgress}
                            >
                                Odeslat emaily
                            </Button>
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>
        </>
    )
}
